import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';

@Component({
  selector: 'app-cadastro-microservicos',
  templateUrl: './cadastro-microservicos.component.html',
  styleUrls: ['./cadastro-microservicos.component.scss']
})
export class CadastroMicroservicosComponent implements OnInit {

  formMicroservico: FormGroup;
  idMicroservicoEdicao: number = 0;
  tituloPagina: string = 'Cadastro de microserviços';

  constructor(
    private fb: FormBuilder,
    private ajaxService: AjaxService,
    private util: UtilService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.inicializarFormulario();
    this.verificarModoEdicao();
  }

  inicializarFormulario(): void {
    this.formMicroservico = this.fb.group({
      item: ['', [Validators.required]],
      descricao: ['', [Validators.required]],
      ativo: [true]
    });
  }

  onSubmit(): void {
    if (this.formMicroservico.valid) {
      this.salvarMicroservico();
    } else {
      this.marcarCamposInvalidos();
    }
  }

  marcarCamposInvalidos(): void {
    Object.keys(this.formMicroservico.controls).forEach(key => {
      const control = this.formMicroservico.get(key);
      if (control?.invalid) {
        control.markAsTouched();
      }
    });
  }

  limparFormulario(): void {
    if (this.idMicroservicoEdicao > 0) {
      this.carregarDadosMicroservico(this.idMicroservicoEdicao);
      return;
    }

    this.formMicroservico.reset({
      item: '',
      descricao: '',
      ativo: true
    });
    this.formMicroservico.markAsPristine();
    this.formMicroservico.markAsUntouched();
  }

  cancelar(): void {
    this.router.navigate(['/consultar-microservicos']);
  }

  private verificarModoEdicao(): void {
    this.route.queryParams.subscribe(params => {
      const idParam = this.toText(params['idMicroservico'] || params['id']);
      const idNumerico = Number(idParam || 0);

      if (idNumerico > 0) {
        this.idMicroservicoEdicao = idNumerico;
        this.tituloPagina = 'Edição de microserviços';
        this.carregarDadosMicroservico(this.idMicroservicoEdicao);
        return;
      }

      const microservicoData = this.toText(params['microservicoData']);
      if (microservicoData) {
        try {
          const item = JSON.parse(microservicoData);
          this.idMicroservicoEdicao = Number(item?.id_microservicos || item?.id || 0);
          this.tituloPagina = this.idMicroservicoEdicao > 0 ? 'Edição de microserviços' : 'Cadastro de microserviços';
          this.preencherFormulario(item);
        } catch {
          this.tituloPagina = 'Cadastro de microserviços';
        }
        return;
      }

      this.idMicroservicoEdicao = 0;
      this.tituloPagina = 'Cadastro de microserviços';
    });
  }

  private carregarDadosMicroservico(id: number): void {
    const url = API + `empresa/Microservicos/GetAsync?id=${id}`;
    this.util.showLoading();
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.util.closeLoading();
        const microservico = response?.data || response;
        if (!microservico) {
          this.util.toasterShowError('Erro', 'Microserviço não encontrado.');
          return;
        }
        this.preencherFormulario(microservico);
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Não foi possível carregar os dados do microserviço.');
      }
    });
  }

  private preencherFormulario(microservico: any): void {
    this.formMicroservico.patchValue({
      item: this.toText(microservico.item || microservico.ITEM),
      descricao: this.toText(microservico.descricao || microservico.DESCRICAO),
      ativo: this.parseBoolean(microservico.ativo ?? microservico.ATIVO ?? true)
    });
  }

  private salvarMicroservico(): void {
    const formValue = this.formMicroservico.value;
    const payload: any = {
      ID_MICROSERVICOS: this.idMicroservicoEdicao > 0 ? this.idMicroservicoEdicao : 0,
      ITEM: this.toText(formValue.item),
      DESCRICAO: this.toText(formValue.descricao),
      ATIVO: this.parseBoolean(formValue.ativo)
    };

    const url = API + 'empresa/Microservicos/SaveAsync';
    this.util.showLoading();
    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar o microserviço.');
          return;
        }

        this.util.toasterShowSuccess('Sucesso', 'Microserviço salvo com sucesso.');
        this.router.navigate(['/consultar-microservicos']);
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao salvar microserviço.');
      }
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.formMicroservico.get(fieldName);
    return field ? field.invalid && field.touched : false;
  }

  getFieldError(fieldName: string): string {
    const field = this.formMicroservico.get(fieldName);
    if (field?.errors) {
      if (field.errors['required']) {
        return 'Este campo é obrigatório.';
      }
    }
    return '';
  }

  private toText(value: any): string {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  private parseBoolean(value: any): boolean {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value === 1;
    const text = this.toText(value).toLowerCase();
    return text === '1' || text === 'true' || text === 'sim' || text === 'yes';
  }
} 